import { Button } from '@jotta/ui/Button'
import { useBrandTheme } from '@jotta/ui/useBrandTheme'
import { LanguageSelector } from '@jotta/ui/LanguageSelector'
import { redirectToLogin } from '@jotta/utils/auth'
import { Trans } from '@lingui/macro'

export const PublicHeader = ({ startSignup }: { startSignup?: () => void }) => {
  const { theme } = useBrandTheme()

  const showLanguageSelector = theme.branding.showLanguageSelector

  return (
    <div className="ml-auto grid h-full auto-cols-min grid-flow-col justify-items-end gap-2 py-2 pr-3 sm:gap-4">
      {startSignup && (
        <Button className="btn btn-primary" onClick={() => startSignup()}>
          <Trans>Sign up</Trans>
        </Button>
      )}
      <Button
        className="btn btn-outline text-current"
        onClick={() => redirectToLogin()}
      >
        <Trans>Log in</Trans>
      </Button>
      {showLanguageSelector && <LanguageSelector />}
    </div>
  )
}
